<small>
  <strong>
    <div [innerHTML]="htmlStandardText"></div>
  </strong>
</small>
<br />
